import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    minWidth: 800,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.form__background_primary,
    padding: theme.spacing(5)
  },
  closeButton: {
    position: 'absolute',
    right: 10,
    top: 10
  },
  title: {
    color: theme.colorPalette.green_75,
    fontSize: 40,
    fontWeight: 300,
    padding: 0,
    marginBottom: theme.spacing(6)
  },
  comparisonRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    marginBottom: theme.spacing(6)
  },
  centerIcon: {
    display: 'flex',
    flexShrink: 0,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  arrowIcon: {
    margin: theme.spacing(0, 4)
  },
  termInfo: {
    display: 'flex',
    flex: 1,
    minWidth: 0,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: theme.spacing(4, 6),
    border: `2px solid ${theme.colorPalette.beige_50}`,
    borderRadius: 6
  },
  termLabel: {
    color: theme.colorPalette.green_75,
    fontWeight: 600,
    fontSize: 14
  },
  priceLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontSize: 10,
    fontWeight: 600,
    textTransform: 'uppercase',
    color: theme.colorPalette.green_75,
    marginRight: theme.spacing(1),
    height: 14,
    marginTop: theme.spacing(2)
  },
  priceColumns: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: theme.spacing(4)
  },
  priceColumn: {
    flex: 1,
    minWidth: 0
  },
  priceRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    gap: theme.spacing(3)
  },
  price: {
    fontSize: 20,
    fontWeight: 400,
    color: theme.colorPalette.green_80
  },
  priceSuperseded: {
    composes: '$price',
    color: theme.colorPalette.beige_90,
    textDecoration: 'line-through'
  },
  alert: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    borderRadius: theme.spacing(4),
    padding: theme.spacing(2),
    fontWeight: 600,
    fontSize: 12,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  green: {
    backgroundColor: theme.colorPalette.green_75_op_30,
    color: theme.colorPalette.green_90
  },
  grey: {
    backgroundColor: theme.colorPalette.beige_50,
    color: theme.colorPalette.beige_90
  },
  red: {
    backgroundColor: theme.colorPalette.red_100_10,
    color: theme.colorPalette.red_100
  },
  unexplainedIncreaseNote: {
    marginBottom: theme.spacing(6),
    padding: theme.spacing(3, 6),
    borderRadius: theme.spacing(2),
    fontSize: 14,
    backgroundColor: theme.colorPalette.beige_50,
    color: theme.colorPalette.green_80
  },
  section: {
    marginBottom: theme.spacing(6),
    backgroundColor: theme.colorPalette.white,
    borderRadius: theme.spacing(2)
  },
  sectionHeader: {
    display: 'flex',
    flexGrow: 0,
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.colorPalette.white_op_10,
    padding: theme.spacing(4, 6)
  },
  sectionTitle: {
    fontWeight: 400,
    fontSize: 20,
    color: theme.colorPalette.green_90
  },
  sectionTotalGroup: {
    display: 'flex',
    alignItems: 'center'
  },
  sectionSummary: {
    fontWeight: 400,
    fontSize: 14,
    color: theme.colorPalette.green_80,
    marginRight: theme.spacing(2)
  },
  iconFold: {
    display: 'block',
    height: 32,
    width: 32,
    transition: 'transform 200ms'
  },
  icon: {
    composes: '$iconFold',
    transform: 'rotate(180deg)'
  },
  row: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3, 6),
    borderTop: `1px solid ${theme.colorPalette.beige_50}`
  },
  rowLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colorPalette.green_75
  },
  rowDetail: {
    fontSize: 12,
    fontWeight: 400,
    color: theme.colorPalette.green_80
  },
  rowAmount: {
    fontSize: 16,
    fontWeight: 600
  },
  discountStatus: {
    composes: '$alert',
    height: 24,
    textTransform: 'uppercase',
    letterSpacing: 0.5
  },
  totalsRow: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(3, 6),
    borderTop: `1px solid ${theme.colorPalette.beige_50}`
  },
  totalsGrandRow: {
    composes: '$totalsRow',
    borderTop: `2px solid ${theme.colorPalette.green_75}`
  },
  totalsLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 400,
    color: theme.colorPalette.green_80
  },
  totalsGrandLabel: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.colorPalette.green_90
  },
  errorState: {
    padding: theme.spacing(8),
    textAlign: 'center',
    fontSize: 16,
    color: theme.colorPalette.red_100
  },
  loadingState: {
    padding: theme.spacing(8),
    textAlign: 'center',
    fontSize: 16,
    color: theme.colorPalette.green_80
  },
  tooltip: {
    marginLeft: theme.spacing(1)
  }
});

export default makeStyles(styles);
